export enum SectionTypeEnum {
  Dynamic = 'Dynamic',
  Static = 'Static',
}
